import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { distinctUntilKeyChanged, filter, Observable, Subject, takeUntil } from 'rxjs';
import { selectHelpers } from '../core/store/helpers/selector/helpers.selectors';
import { Store } from '@ngrx/store';
import { selectSidebar } from '../core/store/animation/selector/animation.selectors';
import { appState } from '..';
import { LadeskChatService } from '../core/services/ladeskChat/ladesk-chat.service';
import { RouterOutlet } from '@angular/router';
import { GlobalNotificationComponent } from '../shared/toaster/global-notification/global-notification.component';
import { FooterComponent } from '../shared/main/footer/footer.component';
import { NgOptimizedImage } from '@angular/common';
import { HeaderComponent } from '../shared/header/header/header.component';
import { SideNavComponent } from '../shared/side-nav/side-nav.component';
import { getRouterSelectors } from '@ngrx/router-store';
import { TranslocoModule } from '@ngneat/transloco';
import { ParticlesBackgroundComponent } from '../shared/animations/particles-background/particles-background.component';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { ScrollToTopService } from '../core/services/scrollToTop/scroll-to-top.service';
import { LocalStorageService } from '../core/services/localStorage/local-storage.service';
import { selectUser } from '../core/store/user/selectors/user.selector';

const easeInOutBtns = trigger('btnTrigger', [
  transition(':enter', [
    animate(
      `500ms`,
      keyframes([
        style({
          opacity: 0,
          right: '-200px',
        }),
        style({
          opacity: 0.5,
          right: '0',
        }),
      ])
    ),
  ]),
  transition(':leave', [
    animate(
      `300ms`,
      keyframes([
        style({
          opacity: 0.5,
          right: '0',
        }),
        style({
          opacity: 0,
          right: '-200px',
        }),
      ])
    ),
  ]),
]);
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: true,
  animations: [easeInOutBtns],
  imports: [
    SideNavComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    ParticlesBackgroundComponent,
    NgOptimizedImage,
    GlobalNotificationComponent,
    TranslocoModule,
  ],
})
export class PagesComponent implements OnInit, OnDestroy {
  unsubus$: Subject<boolean> = new Subject();
  categoryBarStateDestroy$: Subject<boolean> = new Subject();
  helpers$: Observable<any> = this.store.select(selectHelpers);
  sitebar$: Observable<any> = this.store.select(selectSidebar);
  user$: Observable<any> = this.store.select(selectUser);
  delay: ReturnType<typeof setTimeout> = setTimeout(() => {});
  isNotFoundPage: boolean = false;

  slug: string = '';
  isMobile: boolean = true;
  isHiddenBar: boolean = false;
  showBackTop: boolean = false;
  isSportBook: boolean = false;
  isActiveGame: boolean = false;
  extraPadding: boolean = false;
  isLoyaltyPage: boolean = false;
  isAcordionOpen: boolean = false;
  isSideBarOpen: boolean = false;
  isAuth: boolean = false;
  isHovering: boolean = false;
  isLoaded: boolean = false;
  Router$: Observable<any> = this.store.select(getRouterSelectors().selectUrl);
  currentScrollY: number = 0;
  playBubbleAnime: boolean = true;
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const fromTop = document.getElementById('staticHeader')?.getBoundingClientRect().top;
    clearTimeout(this.delay);
    this.delay = setTimeout(() => {
      this.currentScrollY = window.scrollY;
      if (this.currentScrollY > 240 && !this.showBackTop) {
        this.showBackTop = true;
      }
      if (this.currentScrollY < 240 && this.showBackTop) {
        this.showBackTop = false;
      }
      if (fromTop) this.isHiddenBar = fromTop < 50;
    }, 10);
  }
  constructor(
    private store: Store<appState>,
    private liveChat: LadeskChatService,
    private scroll: ScrollToTopService,
    private storageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.sitebar$.pipe(takeUntil(this.unsubus$)).subscribe((res) => {
      if (res?.isLoaded) {
        this.isSideBarOpen = res?.isSitebarOpen && res?.tirggerClose;
      }
    });
    this.user$.pipe(takeUntil(this.unsubus$)).subscribe((res) => {
      if (res.loaded) {
        this.isAuth = res?.isAuth;
      }
    });
    const bubbleAnimStoredValue = this.storageService.getLocalStorage('playBubbleAnim');
    if (bubbleAnimStoredValue !== null) {
      this.playBubbleAnime === JSON.parse(bubbleAnimStoredValue);
    }
    this.Router$.pipe(takeUntil(this.unsubus$)).subscribe((res: any) => {
      setTimeout(() => {
        const isAsideVisible = res.includes('aside') && this.isHiddenBar;

        const categoryBarData = isAsideVisible
          ? {
              data: !isAsideVisible,
            }
          : {
              data:
                (res.includes('games') && !res.includes('aside')) ||
                (res.includes('providers') && !res.includes('aside')) ||
                (res === '/' && window.scrollY !== 0),
            };
        this.isHiddenBar = categoryBarData.data;
      }, 100);

      this.isSportBook = res.includes('1477472');
      this.isActiveGame = res.includes('/game/');
      this.extraPadding = res.includes('games');
      this.isNotFoundPage = res.includes('page-not-found') ? true : false;
    });
    this.helpers$
      .pipe(
        takeUntil(this.unsubus$),
        filter((res) => res.isLoaded),
        distinctUntilKeyChanged('isMobile')
      )
      .subscribe((res) => {
        this.isMobile = res.isMobile;
      });
  }
  openLiveChat() {
    this.liveChat.openLiveAgent({ type: 'liveChat' });
  }
  ngOnDestroy(): void {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
  navigateTop() {
    this.scroll.scrollToTop();
  }
}
